import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { DecisionSource } from '@bpos/v1/over-ask';

import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';
import { BetslipOverAskReviewBaseComponent } from '../../betslip-over-ask-review-base.component';

@Component({
    selector: 'bs-betslip-over-ask-review',
    templateUrl: './betslip-over-ask-review.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask-review.component.scss'],
    standalone: false,
})
export class BetslipOverAskReviewComponent extends BetslipOverAskReviewBaseComponent implements OnInit {
    messages: {
        limitWarning: string;
        badgeTitle: string;
        reviewInfoMessage: string;
        reviewOfferExpires: string;
    };

    OverAskMessagesProvider: OverAskMessagesProvider;

    constructor(overAskMessagesProvider: OverAskMessagesProvider) {
        super();
        this.OverAskMessagesProvider = overAskMessagesProvider;
    }

    ngOnInit(): void {
        this.intiMessages(this.OverAskMessagesProvider);
    }

    intiMessages(overAskMessagesProvider: OverAskMessagesProvider) {
        if (this.decisionSource === DecisionSource.Auto) {
            this.messages = {
                badgeTitle: overAskMessagesProvider.messages.reviewInPlayBadgeTitle,
                limitWarning: overAskMessagesProvider.messages.reviewInPlayInfoMessage,
                reviewInfoMessage: overAskMessagesProvider.messages.reviewInfoMessage,
                reviewOfferExpires: overAskMessagesProvider.messages.reviewOfferExpires,
            };
        } else {
            this.messages = {
                badgeTitle: overAskMessagesProvider.messages.reviewBadgeTitle,
                limitWarning: overAskMessagesProvider.messages.reviewLimitWarning,
                reviewInfoMessage: overAskMessagesProvider.messages.reviewInfoMessage,
                reviewOfferExpires: overAskMessagesProvider.messages.reviewOfferExpires,
            };
        }
    }
}
